import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import {
  View,
  StyleSheet,
  Text,
  Dimensions,
  Animated,
  Easing,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
  scaleSize,
} from "../../../../Utils/responsive";
import DragGames from "./dragGameBalls";

const actualWidth = Dimensions.get("screen").width;
const actualHeigth = Dimensions.get("screen").height;

let deviceWidth = Dimensions.get("window").width;

const isIpad =
  navigator.userAgent.match(/Mac/) &&
  navigator.maxTouchPoints &&
  navigator.maxTouchPoints > 2;

export const DragBalls = (props) => {
  const [PETS, setPets] = useState(
    props.moduleObject.questions[props.moduleIndex].answers
  );
  const [show, setShow] = useState(false);
  const [width, setWidth] = useState(deviceWidth);
  const introAnimation = useRef(new Animated.Value(actualWidth)).current;
  useLayoutEffect(() => {
    Animated.timing(introAnimation, {
      toValue: 0,
      duration: 500,
      useNativeDriver: false,
      easing: Easing.linear,
    }).start();
  });

  Dimensions.addEventListener("change", (e) => {
    deviceWidth = e.window.width;
    setWidth(deviceWidth);
  });

  useEffect(() => {
    let moduleIdEsg = props.resultContext.result.modules.filter(
      (mod) => mod.moduleid === props.moduleObject.moduleid
    );
    if (props.moduleObject.questions[props.moduleIndex].askif) {
      if (props.moduleObject.questions[props.moduleIndex].askif.op == "AND") {
        props.moduleObject.questions[props.moduleIndex].askif.answers.forEach(
          (val) => {
            let ifExist = moduleIdEsg[0].responses.filter(
              (mod) => mod.qid == val.qid && mod.respid == val.respid
            );
            if (ifExist.length > 0) {
              setShow(true);
            } else {
              if (props.moduleIndex < props.numberOfQuestions - 1) {
                props.setModuleIndex((moduleIndex) => moduleIndex + 1);
              } else {
                if (moduleIdEsg[0].completedat == null) {
                  props.resultContext.setModuleCompletedAtTime(
                    props.moduleObject.moduleid
                  );
                  props.history.push("/");
                }
              }
            }
          }
        );
      }
    }
  }, []);

  return (
    show && (
      <Animated.View
        style={[
          {
            justifyContent: actualWidth > 750 ? "space-evenly" : "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            transform: [{ translateX: introAnimation }],
          },
        ]}
      >
        <Text
          style={[
            styles.customText,
            isIpad && {
              width:
                width > 1250
                  ? wp("75%")
                  : width > 1000
                  ? "862px"
                  : width > 400
                  ? wp("85%")
                  : wp("90%"),
            },
          ]}
        >
          {props.moduleObject.questions[props.moduleIndex].text}
        </Text>
        <Text style={styles.headerSubText}>Choose one</Text>
        {actualWidth < 520 && <View style={styles.line} />}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: actualWidth > 1000 ? "75%" : "90%",
          }}
        >
          {PETS.map((pet, index) => {
            if (actualWidth > 550) {
              return (
                <View
                  style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: isIpad && width > 1000 ? "212px" : "33%",
                  }}
                  key={index}
                >
                  <Text style={styles.headingText}>{pet.text}</Text>
                  <Text style={styles.subHeading}>
                    {pet.metadata.description}
                  </Text>
                  <DragGames
                    onClick={props.onItemClick}
                    iconKey={pet.metadata.iconkey}
                    {...pet}
                  />
                </View>
              );
            } else if (index < 2) {
              return (
                <View
                  style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "50%",
                  }}
                  key={index}
                >
                  <Text style={styles.headingText}>{pet.text}</Text>
                  <Text style={styles.subHeading}>
                    {pet.metadata.description}
                  </Text>
                  <DragGames
                    onClick={props.onItemClick}
                    iconKey={pet.metadata.iconkey}
                    {...pet}
                  />
                </View>
              );
            }
          })}
        </View>
        {PETS.map((pet, index) => {
          if (actualWidth < 550 && index == 2) {
            return (
              <View
                style={{
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop:
                    actualWidth > 1000 &&
                    actualWidth < 1200 &&
                    actualHeigth < 900
                      ? "-5%"
                      : actualWidth < 330 && -20,
                }}
                key={index}
              >
                <Text style={[styles.headingText, { marginBottom: 0 }]}>
                  {pet.text}
                </Text>
                <DragGames
                  onClick={props.onItemClick}
                  iconKey={pet.metadata.iconkey}
                  {...pet}
                />
              </View>
            );
          }
        })}
      </Animated.View>
    )
  );
};
const styles = StyleSheet.create({
  headerSubText: {
    fontSize: scaleSize(actualWidth > 1000 ? 16 : actualWidth > 400 ? 10 : 10),
    color: "var(--text-color-default)",
    letterSpacing: actualWidth > 1000 ? 1.6 : actualWidth > 400 ? 1.2 : 1,
    fontWeight: "var(--font-weight-light)",
    textAlign: "center",
    marginBottom: actualWidth > 750 ? 0 : actualWidth > 400 ? 8 : 8,
  },
  headingText: {
    marginBottom: 10,
    fontSize: scaleSize(actualWidth > 1000 ? 24 : actualWidth > 400 ? 20 : 12),
    color: "var(--text-color-default)",
    letterSpacing: actualWidth > 1000 ? 3.2 : actualWidth > 400 ? 3.2 : 1.6,
    fontWeight: "var(--font-weight-light)",
    textAlign: "center",
  },
  subHeading: {
    fontSize: scaleSize(actualWidth > 600 ? 16 : actualWidth > 400 ? 12 : 10),
    color: "var(--text-color-default)",
    letterSpacing: actualWidth > 600 ? 1.6 : actualWidth > 400 ? 1.6 : 1.2,
    fontWeight: "var(--font-weight-light)",
    textAlign: "center",
  },
  customText: {
    width: "75%",
    fontSize: "var(--module-detail-header-font-size)",
    textAlign: "center",
    color: "var(--text-color-default)",
    marginBottom: actualWidth > 700 ? hp("4%") : hp("2%"),
    fontWeight: "var(--font-weight-light)",
    letterSpacing: "var(--module-detail-header-letter-spacing)",
  },
  line: {
    width: actualWidth > 400 ? wp("35%") : wp("30%"),
    height: 1,
    backgroundColor: "#d4d4d4",
    marginBottom: actualWidth > 700 ? hp("4%") : hp("2%"),
  },
});
